<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      class="queryonlinenavbar"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="01">清单公示</el-menu-item>
      <el-menu-item index="02">执法信息</el-menu-item>
      <el-menu-item index="03">办事指南</el-menu-item>
      <el-menu-item index="04">服务制度</el-menu-item>
      <el-menu-item index="05">监督举报</el-menu-item>
    </el-menu>
    <listpublic v-if=" activeIndex === '01'"></listpublic>
    <lawEnforcementInfo v-else-if=" activeIndex === '02'"></lawEnforcementInfo>
    <handlerGuide v-else-if=" activeIndex === '03'"></handlerGuide>
    <serveSystem class="line" v-else-if=" activeIndex === '04'">服务制度</serveSystem>
    <div class="line" v-else-if=" activeIndex === '05'">监督举报</div>
  </div>
</template>
<script>
import listpublic from "@/pages/queryOnline/childPage/listPublic.vue";
import lawEnforcementInfo from "@/pages/queryOnline/childPage/lawEnforcementInfo.vue";
import handlerGuide from "@/pages/queryOnline/childPage/handlerGuide.vue";
import serveSystem from "@/pages/queryOnline/childPage/serveSystem.vue";

export default {
  data() {
    return {
      activeIndex: "01"
    };
  },
  components: {
    listpublic,
    lawEnforcementInfo,
    handlerGuide,
    serveSystem
  },
  mounted() {
    this.is_route_params_null();
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    is_route_params_null() {
      if (JSON.stringify(this.$route.params) == "{}") {
        this.activeIndex = "01";
      } else {
        if (this.$route.params.type_id == "01") {
          this.activeIndex = "01";
        } else if (this.$route.params.type_id == "02") {
          this.activeIndex = "02";
        } else if (this.$route.params.type_id == "03") {
          this.activeIndex = "03";
        } else if (this.$route.params.type_id == "04") {
          this.activeIndex = "04";
        } else if (this.$route.params.type_id == "05") {
          this.activeIndex = "05";
        }
      }
    }
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/queryOnline/index.vue


// WEBPACK FOOTER //
// src/pages/queryOnline/index.vue